module.exports = __webpack_public_path__ + "logo.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/logo.png
 ** module id = 748
 ** module chunks = 0
 **/